/*
 * filename: table.js
 * Get the user data from store and show
 * */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import { Field, reduxForm, reset } from 'redux-form';

import { renderTextField } from '../components/reduxFields';
import SortingCustom from '../components/SortingCustom';
import { showFormatedDate, base64Encode, resetFiltersAndSorting } from '../actions/utilAction';
import PaginatorCustom from '../components/paginationCustom';
import { getOrganizationStaffDocuments } from '../modules/Dashboards/actions/StaffDashboardActions';
import { getExportCSVOrExcelStaffDocuments } from '../modules/Dashboards/actions/StaffDashboardActions';
/**
 * A simple table demonstrating the hierarchy of the `Table` component and its sub-components.
 */
class OrganizationStaffDocuemntsTable extends Component {

  constructor(props) {
    
    super(props);
    this.state = {
      pageNumber:0
    }
    this.filter = {
      sort_Column: '',
      sort_order: '',
      searchText: '',
    };
    this.handleSearchStaffDocs = this.handleSearchStaffDocs.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
  }

  loadOrganizationStaffDocuments(page_number) {
    let searchObj1 = {
      pageNumber: page_number ? page_number : 1,
      pageSize: 10,
      sort_fields: this.filter.sort_Column || '',
      sort_order: this.filter.sort_order || '',
      contain_filters: { SearchText: this.filter.searchText||''},
    };
    this.props.SendQueryparams(searchObj1)
    this.props.getOrganizationStaffDocuments(searchObj1);
  }

  handleSearchStaffDocs() {
    return false;
  }

  handleReset = () => {
    this.props.dispatch(reset('OrganizationStaffDocuemntsTable'));
    resetFiltersAndSorting(this.filter, 'id', true);
    this.filter.sort_Column = '';
    this.filter.sort_order = '';
    this.loadOrganizationStaffDocuments();
  };

  handleSearchChange(event) {
    if (event.target.value.length > 0) {
      this.filter.searchText = event.target.value;
      this.loadOrganizationStaffDocuments();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadOrganizationStaffDocuments();
    }
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_order = col_order;
      this.loadOrganizationStaffDocuments();
    }
  }


  showTableData() {
    return this.props.OrganizationStaffDocmuents.data.map((data) => {
      let staffId = base64Encode(`${data.staffId}`);
      return (
        <TableRow key={data.authorizationId} style={{ background: `${data.warningColorCode}` }}>
          {/* <TableRowColumn style={{width : '35%'}}>{data.staffName}</TableRowColumn> */}
          <TableRowColumn style={{ width: '35%' }}><NavLink to={`/user-documents/${staffId}`} exact >{data.staffName}</NavLink></TableRowColumn>
          <TableRowColumn style={{ width: '40%' }}>{data.otherDocumentType ? `${data.documentTypeName} (${data.otherDocumentType})` : data.documentTypeNameStaff}</TableRowColumn>
          <TableRowColumn style={{ width: '25%' }}>{showFormatedDate(data.expiration)}</TableRowColumn>
        </TableRow>
      );
    });
  }

  render() {
    const { handleSubmit, OrganizationStaffDocmuents } = this.props;
    const staffDocsList =  (OrganizationStaffDocmuents && OrganizationStaffDocmuents.data) || []
    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
            <div className="row end-flex">
              <div className="col-sm-9 mtm-27">
                <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchStaffDocs)}>
                  <Field
                    name="staffDocs"
                    floatingLabelText="Search"
                    maxLength='25'
                    onChange={this.handleSearchChange}
                    component={renderTextField}
                  />
                </form>
              </div>
              <div className="reset-btn col-sm-3 btn_rt">
                <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
              </div>
            </div>
          </div>
        </div>
        <Table>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow >
              <TableHeaderColumn style={{ width: '35%' }}>
                <SortingCustom noSort={!staffDocsList.length} setSortColumn={this.setSortColumn} columnName='staffName' displayName='Staff Name' />
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '40%' }}>Document Type</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '25%' }}><SortingCustom noSort={!staffDocsList.length} setSortColumn={this.setSortColumn} columnName='expiration' displayName='Expiration Date' /></TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {this.props.OrganizationStaffDocmuents && this.props.OrganizationStaffDocmuents.data && this.props.OrganizationStaffDocmuents.data.length > 0 ?
              this.showTableData()
              :
              <TableRow>
                <TableRowColumn colSpan="3">No Record Found</TableRowColumn>
              </TableRow>
            }
          </TableBody>
        </Table>
        {this.props.OrganizationStaffDocmuents.data && this.props.OrganizationStaffDocmuents.data.length ?
          <PaginatorCustom data={this.props.OrganizationStaffDocmuents.meta} handlePageChange={(page_number) => this.loadOrganizationStaffDocuments(page_number)} />
          : null}
      </div>
    );
  }
}

OrganizationStaffDocuemntsTable = reduxForm({
  form: 'OrganizationStaffDocuemntsTable',
})(OrganizationStaffDocuemntsTable);

function mapStateToProps(state) {
  //  console.log('state.staff_dashboard.OrganizationStaffDocuments..............', state.staff_dashboard ? state.staff_dashboard.OrganizationStaffDocuments : {},);
  return {
    OrganizationStaffDocmuents: state.staff_dashboard ? state.staff_dashboard.OrganizationStaffDocuments : {},
    LeftPanel_loading: state.staff_dashboard.LeftPanel_loading,
  };
}

export default connect(mapStateToProps, { getOrganizationStaffDocuments,getExportCSVOrExcelStaffDocuments })(OrganizationStaffDocuemntsTable);



// WEBPACK FOOTER //
// ./src/adminCharts/OrganizationStaffDocuemntsTable.js